<template>
  <li :class="props.disabled && 'disabled'">
    <router-link :to="href" v-if="href && !props.disabled && !loading">
      <button
        :disabled="props.disabled"
        :class="[
          'tw-flex tw-items-center',
          textColor,
          props.disabled && 'tw-cursor-not-allowed tw-opacity-50',
        ]"
      >
        <base-icon v-if="iconName" :icon="iconName" class="tw-ml-2" />
        {{ props.text }}
      </button>
    </router-link>

    <button
      v-else
      :disabled="props.disabled"
      @click="emit('click')"
      :class="[
        'tw-flex tw-items-center',
        textColor,
        props.disabled && 'tw-cursor-not-allowed tw-opacity-50',
      ]"
    >
      <base-icon v-if="iconName" :icon="iconName" class="tw-ml-2" />
      <span>{{ props.text }}</span>
      <loading-spinner
        :show="true"
        v-if="props.loading"
        size="sm"
        class="tw-inline-block tw-mr-2 tw-align-middle"
      />
    </button>
  </li>
</template>

<script setup>
import BaseIcon from '@/components/base/BaseIcon.vue'
import { ref } from 'vue'
import LoadingSpinner from '@/components/loading/LoadingSpinner.vue'
const text = ref('')

const emit = defineEmits(['click'])

const props = defineProps({
  iconName: { type: String, default: null },
  text: { type: String, default: '' },
  href: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  textColor: { type: String, default: 'tw-text-blue-dark-400' },
})
</script>

<style scoped>
button {
  @apply tw-bg-none tw-w-full tw-h-full tw-px-4 tw-py-2 tw-cursor-pointer tw-text-right;
}
</style>
